import { FRONT_END_VERSION } from '../../Constants';
import { globalizeSelectors } from '../Utils';
import type {
  SWUpdateInstalledVersions,
  SWUpdateState,
  SWUpdateVersions,
  UpdateCheckerAction,
  UpdateCheckerState,
} from '../types/UpdateChecker';

const types = {
  POLL_START: 'UPDATE_CHECKER/POLL_START',
  POLL_STOP: 'UPDATE_CHECKER/POLL_STOP',
  VERSION: 'UPDATE_CHECKER/VERSION',
  STATE: 'UPDATE_CHECKER/STATE',
  APPROVE_DOWNLOAD: 'UPDATE_CHECKER/APPROVE_DOWNLOAD',
  START_UPDATE: 'UPDATE_CHECKER/START_UPDATE',
  CHECK_NOW: 'UPDATE_CHECKER/CHECK_NOW',
  SW_VERSIONS: 'UPDATE_CHECKER/SW_VERSIONS',
} as const;

const mountPath = 'update_checker'; // mount point in global state, must match root reducer

// See this
// https://hackernoon.com/my-journey-toward-a-maintainable-project-structure-for-react-redux-b05dfd999b5

const actions = {
  setSWupdateState: (
    state: SWUpdateState
  ): UpdateCheckerAction<SWUpdateState> => ({
    type: types.STATE,
    payload: state,
  }),
  setVersions: (
    state: SWUpdateInstalledVersions
  ): UpdateCheckerAction<SWUpdateInstalledVersions> => ({
    type: types.SW_VERSIONS,
    payload: state,
  }),
  startUpdateChecking: (): UpdateCheckerAction => ({ type: types.POLL_START }),
  stopUpdateChecking: (): UpdateCheckerAction => ({ type: types.POLL_STOP }),
  checkNow: (): UpdateCheckerAction => ({ type: types.CHECK_NOW }),
  approveDownload: (): UpdateCheckerAction => ({
    type: types.APPROVE_DOWNLOAD,
  }),
  startUpdate: (): UpdateCheckerAction => ({ type: types.START_UPDATE }),
};

const initialState: UpdateCheckerState = {
  has_update: false,
  version_details: null,
  swupdate_state: null,
  sw_versions: null,
};

function payloadAs<Payload>(action: UpdateCheckerAction): Payload {
  return action.payload as Payload;
}

function reducer(
  state: UpdateCheckerState = initialState,
  action: UpdateCheckerAction
): UpdateCheckerState {
  switch (action.type) {
    case types.POLL_STOP: {
      return {
        ...state,
        has_update: false,
        version_details: null,
        swupdate_state: null,
      };
    }
    case types.VERSION: {
      const versionDetails = payloadAs<SWUpdateVersions>(action);
      return {
        ...state,
        version_details: versionDetails,
        has_update: versionDetails.front_version !== FRONT_END_VERSION,
      };
    }
    case types.STATE: {
      return {
        ...state,
        swupdate_state: payloadAs<SWUpdateState>(action),
      };
    }
    case types.SW_VERSIONS: {
      return {
        ...state,
        sw_versions: payloadAs<SWUpdateInstalledVersions>(action),
      };
    }
    default: {
      return state;
    }
  }
}

//export { types as actionTypes, actions as default, reducer };

const localSelectors = {
  version_details: (
    state: UpdateCheckerState
  ): UpdateCheckerState['version_details'] => state.version_details,
};

const selectors = globalizeSelectors(localSelectors, mountPath);

export { types as actionTypes, actions as default, selectors, reducer };
